import { FiCheckCircle } from "react-icons/fi";
import { useApplication } from "../../contexts/ApplicationContext";
import { formatToReal } from "../../utils/utils";
import { HiOutlineClipboardList } from "react-icons/hi";

const CardQueryDescription = ({
  title,
  infos = [],
  children,
  price,
  description = "",
}) => {
  const { user } = useApplication();

  return (
    <div className="relative overflow-hidden rounded-2xl shadow-lg border border-gray-200 mx-auto mb-4">
      {/* Fundo com imagem e overlay */}
      <div
        className="relative bg-cover bg-top bg-no-repeat"
        style={{ backgroundImage: "url('/assets/bg_form.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/70" />
        <div className="relative z-10 px-8 py-12 md:px-12 md:py-16 text-white">
          {/* Ícone + título */}
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-white/10 p-3 rounded-xl">
              <HiOutlineClipboardList className="text-3xl" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight leading-tight">
              {title}
            </h1>
          </div>

          {description && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 text-white/90 text-base md:text-lg mb-6 max-w-2xl">
              {description.split(/\s[|l]\s/).map((item, index) => (
                <div key={index} className="flex items-start gap-2 text-sm">
                  <FiCheckCircle
                    className="mt-1 text-green-400"
                    style={{ minWidth: "20px" }}
                  />
                  <span className="leading-relaxed">{item.trim()}</span>
                </div>
              ))}
            </div>
          )}
          {/* Preço */}
          {/* {user?.Company?.showPriceQuery && (
            <div className="flex items-center gap-3 bg-white/10 border border-white/20 rounded-xl px-5 py-4 w-fit backdrop-blur-md shadow-md mb-5">
              <div className="bg-white/20 text-white rounded-full w-10 h-10 flex items-center justify-center text-sm font-bold shadow">
                R$
              </div>
              <div className="font-bold text-xl md:text-2xl tracking-tight">
                {formatToReal(price)}
                <div className="text-xs font-medium text-white/80 mt-1">
                  Valor da consulta
                </div>
              </div>
            </div>
          )} */}

          {/* Infos */}
          {infos.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {infos.map((info, i) => (
                <span
                  key={i}
                  className="bg-white/10 text-white text-xs font-medium px-3 py-1 rounded-full border border-white/20 backdrop-blur-sm"
                >
                  {info}
                </span>
              ))}
            </div>
          )}

          {/* Rodapé de ação */}
          <div className="bg-white rounded-lg w-fit border-t border-gray-200 mt-8">
            {children}
          </div>
        </div>
      </div>

      {/* Logo no fundo (marca d’água sutil) */}
      <div className="absolute bottom-5 right-4 opacity-1 z-10">
        <img src="/assets/logo-white.png" alt="Logo" className="w-32" />
      </div>
    </div>
  );
};

export default CardQueryDescription;
